{
  "_meta": {
    "_comment": "merchant-v3 catalog namespace EN. CatalogSidebar left rail + Task 35 copack browse.",
    "locale": "en",
    "completeness": "secondary",
    "vg-binding": "P14.1.D-15,P14.1.D-16"
  },
  "sidebar": {
    "categories": "Categories",
    "filters": "Filters",
    "priceRange": "Price range",
    "min": "Min",
    "max": "Max"
  },
  "copack": {
    "page": {
      "title": "Co-pack shipping groups",
      "subtitle": "Browse consolidated shipping groups to plan cheaper fulfillment."
    },
    "filter": {
      "label": "Filter by blueprint",
      "placeholder": "Blueprint ID",
      "apply": "Apply",
      "clear": "Clear"
    },
    "table": {
      "groupKey": "Group",
      "location": "Location",
      "packingClass": "Packing class",
      "blueprints": "Blueprints",
      "shipping": "Sample shipping",
      "additional": "Additional item"
    },
    "blueprintsCount_one": "{{count}} blueprint",
    "blueprintsCount_other": "{{count}} blueprints",
    "state": {
      "loading": "Loading co-pack groups…",
      "empty": {
        "title": "No co-pack groups",
        "body": "No consolidated shipping groups match your filter."
      },
      "error": "Could not load co-pack groups.",
      "retry": "Retry"
    },
    "pagination": {
      "page": "Page {{page}} of {{pages}}",
      "prev": "Previous",
      "next": "Next"
    }
  }
}
